import axios from "axios";

export const getAllTahun = async () => {
  return await axios.get(`${window._HOST}admin/tahun/`, {
    withCredentials: true,
  });
};

export const getAllDataTableTahun = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/tahun/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/tahun/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getDropdownTahun = async () => {
  return await axios.get(`${window._HOST}admin/tahun/dropdown`, {
    withCredentials: true,
  });
};

export const getDropdownValueTahun = async () => {
  return await axios.get(`${window._HOST}admin/tahun/dropdownValue`, {
    withCredentials: true,
  });
};

export const getDropdownTahunValue = async () => {
  return await axios.get(`${window._HOST}admin/tahun/dropdownValue`, {
    withCredentials: true,
  });
};

export const insertNewDataTahun = async (formData) => {
  return await axios.post(`${window._HOST}admin/tahun`, formData, {
    withCredentials: true,
  });
};

export const updateDataTahun = async (formData, id) => {
  return await axios.put(`${window._HOST}admin/tahun/${id}`, formData, {
    withCredentials: true,
  });
};

export const deleteDataTahun = async (id) => {
  return await axios.delete(`${window._HOST}admin/tahun/${id}`, {
    withCredentials: true,
  });
};
